import { Accept } from 'react-dropzone';

export const FILE_MAX_SIZE_FILED_MB = 10;

export const FILE_ACCEPT_IMAGE_ONLY: Accept = {
  'image/webp': ['.webp'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
};

export const FILE_ACCEPT_DOCUMENT: Accept = {
  ...FILE_ACCEPT_IMAGE_ONLY,
  'application/pdf': ['.pdf'],
};
